import { Cookies } from 'react-cookie';

import { UpdateHub } from 'api/traps/types';
import axiosInterceptor from 'api/interceptor/axiosClient';

export const updateHub = async (info: { hubId: number; hubInfo: UpdateHub }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/hub_update/${info.hubId}`,
    {
      ...info.hubInfo,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as UpdateHub;
};
